module.exports = __webpack_public_path__ + "static/Homepage-Hero3-c1a9852bbdceacf51343e063732f7814.png";